/**
 * @Author: v_jppjpeng
 * @Date: 2023-03-29 20:47:50
 * @Explain: 缺省页
 */

import { Link } from '@/components/tdesign';
import { intlGet } from '@/locales';
import classNames from 'classnames';
import { CSSProperties, ReactNode, useCallback, useMemo } from 'react';
import { Loading, LoadingProps } from 'tdesign-react';
// type
import { DefaultPageStatusEnum } from '../data.d';

type PropsType = {
  className?: string;
  style?: CSSProperties;
  containerStyle?: CSSProperties;
  column?: 'block' | 'inline';
  status: DefaultPageStatusEnum | string;
  isShowTextContent?: Boolean;
  imgSrc?: any;
  textContent?: ReactNode;
  retryText?: string;
  btnGroup?: ReactNode;
  loadingSize?: LoadingProps['size'];
  onRetry?: () => void;
};

export default function DefaultPage(props: PropsType) {
  const {
    className,
    column = 'block',
    style,
    containerStyle,
    status,
    isShowTextContent = true,
    imgSrc,
    textContent,
    retryText = intlGet('COMMON.RETRY'),
    btnGroup,
    loadingSize = 'small',
    onRetry,
  } = props;

  // const getImg = (name: string) => getImgUrl(`/defaultPage/${name}`);

  const renderJson = useMemo(
    () => ({
      /** 无数据 - 默认 */
      [DefaultPageStatusEnum.NO_DATA]: {
        imgSrc: '',
        textContent: textContent || intlGet('COMMON.NO.DATA'),
      },
      /** 无数据 - 搜索/筛选 */
      [DefaultPageStatusEnum.SEARCH_NO_DATA]: {
        imgSrc: '',
        textContent: textContent || intlGet('COMMON.NO.DATA'),
      },
      /** 无数据 - 报表 */
      [DefaultPageStatusEnum.NO_DATA_REPORT]: {
        imgSrc: '',
        textContent: textContent || intlGet('COMMON.NO.DATA'),
      },
      /** 无权限 */
      [DefaultPageStatusEnum.NO_AUTH]: {
        imgSrc: '',
        textContent,
      },
      /** 网络连接失败 */
      [DefaultPageStatusEnum.NO_NETWORK]: {
        imgSrc: '',
        textContent: textContent || (
          <>
            {intlGet('COMMON.NO.LOADING.FAILED')}
            {onRetry && (
              <Link className="ml-10" onClick={onRetry}>
                {retryText}
              </Link>
            )}
          </>
        ),
      },
      /** 自定义 */
      [DefaultPageStatusEnum.CUSTOM]: {
        imgSrc,
        textContent,
      },
    }),
    [imgSrc, textContent, onRetry],
  );

  const getKeyValue = useCallback(
    (key: string) => (renderJson as any)?.[status]?.[key],
    [status],
  );
  return (
    <div
      className={classNames(
        'default-page-components',
        { inline: column === 'inline' },
        className,
      )}
      style={style}
    >
      <div
        className={classNames('box-container', {
          active: status !== DefaultPageStatusEnum.CUSTOM,
        })}
        style={containerStyle}
      >
        {status === DefaultPageStatusEnum.LOADING ? (
          <Loading
            size={loadingSize}
            text={
              <span className="ml-5">
                {textContent || intlGet('COMMON.LOADING')}
              </span>
            }
          />
        ) : (
          <>
            {status === DefaultPageStatusEnum.CUSTOM && (
              <div className="image">
                <img src={getKeyValue('imgSrc')} />
              </div>
            )}

            {isShowTextContent && getKeyValue('textContent') && (
              <div className="text-content">{getKeyValue('textContent')}</div>
            )}
            {btnGroup && <div className="btn-group">{btnGroup}</div>}
          </>
        )}
      </div>
    </div>
  );
}
